module.exports = __webpack_public_path__ + "static/img/t1-6.f94f18d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/t1-6.jpg
// module id = fDaR
// module chunks = 1